'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Magnet';

var EntypoMagnet = function EntypoMagnet(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M12.165,17.86c-0.028,0.309,0.217,0.584,0.545,0.611l3.985,0.326c0.329,0.027,0.621-0.203,0.65-0.512l0.311-3.287l-5.18-0.426L12.165,17.86z M2.344,14.999l0.312,3.287c0.028,0.309,0.321,0.539,0.65,0.512l3.985-0.326c0.328-0.027,0.573-0.303,0.546-0.611l-0.312-3.287L2.344,14.999z M1.831,9.583l0.321,3.391l5.181-0.426L7.011,9.161c-0.007-0.082-0.011-0.166-0.011-0.25c0-1.555,1.346-2.82,3-2.82s3,1.266,3,2.82c0,0.084-0.004,0.168-0.012,0.25l-0.321,3.387l5.181,0.426l0.321-3.391c0.021-0.225,0.03-0.449,0.03-0.672C18.2,4.659,14.522,1.2,10,1.2S1.8,4.659,1.8,8.911C1.8,9.134,1.811,9.358,1.831,9.583z' })
    );
};

exports.default = EntypoMagnet;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo-icons/lib/entypo/Magnet.js
// module id = 662
// module chunks = 168707334958949